"use client";

import { useRef } from "react";
import { useServerInsertedHTML } from "next/navigation";
import { appearanceBootstrap } from "./theme";

export function AppearanceBootstrap({ nonce }: { nonce?: string }) {
  const inserted = useRef(false);
  useServerInsertedHTML(() => {
    if (inserted.current) return null;
    inserted.current = true;
    return <script id="appearance-bootstrap" nonce={nonce} dangerouslySetInnerHTML={{ __html: appearanceBootstrap }} />;
  });
  // The browser renders no script node; initialization is emitted only in SSR HTML.
  return null;
}
